import React, {Component} from 'react';
import styles from 'css/components/footer.css';

/**
 * Footer
 */
export default class Footer extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <footer className={styles.footer}>
        <div className={styles.frame}>
          (C) BILCOM Inc. All Rights Reserved.
        </div>
      </footer>
    );
  }
}





// WEBPACK FOOTER //
// ./src/js/components/footer/index.js